// frontend/src/pages/AvatarSelection.js
import React, { useState, useContext } from 'react';
import api from '../api';
import { AuthContext } from '../context/AuthContext';
import './AvatarSelection.css';

function AvatarSelection() {
  const categories = {
    "Animales": ["🐱", "🐶", "🦊", "🐻", "🐼"],
    "Símbolos": ["⭐", "🔥", "💎", "⚡", "☯"],
    "Emojis": ["😀", "😂", "😎", "😍", "🤩"]
  };

  const categoryNames = Object.keys(categories);
  const [selectedCategory, setSelectedCategory] = useState(categoryNames[0]);
  const [index, setIndex] = useState(0);
  const [selectedAvatar, setSelectedAvatar] = useState(categories[selectedCategory][0]);
  const [message, setMessage] = useState("");
  const { user, updateUserAvatar } = useContext(AuthContext);

  const handleCategoryChange = (e) => {
    const newCategory = e.target.value;
    setSelectedCategory(newCategory);
    setIndex(0);
    setSelectedAvatar(categories[newCategory][0]);
  };

  const handleSliderChange = (e) => {
    const newIndex = parseInt(e.target.value, 10);
    setIndex(newIndex);
    setSelectedAvatar(categories[selectedCategory][newIndex]);
  };

  const handleConfirm = async () => {
    if (!user) {
      setMessage("Debes iniciar sesión para cambiar avatar.");
      return;
    }
    try {
      // Enviar solo 'avatar'; el backend toma userId de req.user
      const res = await api.post('/profile/avatar/update-avatar', {
        avatar: selectedAvatar
      });
      // Se asume que response incluye user con campo avatar actualizado
      if (res.data?.user?.avatar) {
        updateUserAvatar(res.data.user.avatar);
        setMessage("Avatar actualizado exitosamente!");
      } else {
        setMessage("Avatar actualizado, pero no se recibió confirmación.");
      }
    } catch (error) {
      console.error("Error actualizando avatar:", error.response ? error.response.data : error.message);
      if (error.response?.status === 401) {
        setMessage("No autorizado. Inicia sesión de nuevo.");
      } else {
        setMessage("Error actualizando avatar.");
      }
    }
  };

  return (
    <div className="avatar-selection-container">
      <h1>Selecciona tu Avatar</h1>
      <div className="category-selector">
        <label>Elige categoría:</label>
        <select value={selectedCategory} onChange={handleCategoryChange}>
          {categoryNames.map(cat => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>
      </div>
      <div className="avatar-preview">
        <p>Avatar seleccionado:</p>
        <div className="avatar-icon">{selectedAvatar}</div>
      </div>
      <div className="slider-container">
        <label>Desliza para elegir:</label>
        <input
          type="range"
          min="0"
          max={categories[selectedCategory].length - 1}
          value={index}
          onChange={handleSliderChange}
        />
      </div>
      <button onClick={handleConfirm}>Confirmar Avatar</button>
      {message && <p className="message">{message}</p>}
    </div>
  );
}

export default AvatarSelection;
